import {
  useLocation,
  Navigate,
  Outlet,
  useOutletContext,
} from "react-router-dom";
import useAuth from "./useAuth";

const RequireAuth = ({ allowedPages }) => {
  const { auth } = useAuth();
  const location = useLocation();
  const layoutContext = useOutletContext();

  // return auth?.role ? (
  //   <Outlet context={layoutContext} />
  // ) : auth?.user ? (
  //   <Navigate to="/unauthorized" state={{ from: location }} replace />
  // ) : (
  //   <Navigate to="/login" state={{ from: location }} replace />
  // );

  // Not logged in
  if (!auth?.accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Logged in but no restriction passed
  if (!allowedPages) {
    return <Outlet context={layoutContext} />;
  }

  // Check if user has permission
  const hasAccess = auth?.pages?.some((page) => allowedPages.includes(page));

  return hasAccess ? (
    <Outlet context={layoutContext} />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};

export default RequireAuth;
